/* eslint-disable react/prop-types */
import { IconButton, makeStyles, Popover, Tooltip } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TiTrash } from "react-icons/ti";
import { HiOutlineDotsVertical } from "react-icons/hi";
import withExportScenario from "app/common/scenario/withExportScenario";
import { RiFileExcel2Line } from "react-icons/ri";
import { setSelectedScenarios } from "../duck/slices";

// eslint-disable-next-line no-unused-vars
const myStyles = makeStyles((theme) => ({
  button: {
    boxSizing: "border-box",
    border: "none",
    background: "none",
    padding: "0",
    // "&:active": { background: "#e07670" },
    borderRadius: "9999px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  scenarioActions: {
    display: "flex",
    // width: "100px",
    backgroundColor: "white",
    borderRadius: "5px",
    justifyContent: "space-evenly",
    borderTop: "1px solid #e2e2e2",
    padding: "15px",
    gap: "15px",
  },
}));

const ScenarioOptions = ({ scenarioId }) => {
  const classes = myStyles();
  const dispatch = useDispatch();
  const { selectedScenarios } = useSelector((state) => state.summary);
  const { referenceScenario, totalsByScenarioId } = useSelector(
    (state) => state.scenarios
  );
  const configCatSlice = useSelector((state) => state.auth.configCatUser);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? "simple-popover" : undefined;

  const handleRemoveScenario = (id) => {
    const set = new Set(selectedScenarios);
    if (referenceScenario.scenario_id === id) return;
    set.delete(id);
    dispatch(setSelectedScenarios(Array.from(set)));
  };

  const buttonWithBehavior = (withFunction, scenario, icon, title) =>
    withFunction(
      (p) => (
        <Tooltip title={title} disableFocusListener>
          <IconButton
            aria-label="expand row"
            size="small"
            // classes={{
            //   root: classes.expandButton,
            // }}
            disabled={
              configCatSlice?.features?.IsMaintenanceActive &&
              title === "Copy scenario"
            }
            disableRipple
            onClick={(e) => {
              e.stopPropagation();
              p.onClick(e);
            }}
          >
            {icon}
          </IconButton>
        </Tooltip>
      ),
      scenario
    );

  const ButtonWithExportScenario = buttonWithBehavior(
    withExportScenario,
    totalsByScenarioId[scenarioId].scenario,
    <RiFileExcel2Line color="#e07670" size={25} />,
    "Export to Excel"
  );

  return (
    <>
      {referenceScenario.scenario_id !== scenarioId && (
        <>
          <button
            type="button"
            aria-describedby={popoverId}
            variant="contained"
            color="primary"
            onClick={handleClick}
            className={classes.button}
          >
            <HiOutlineDotsVertical color="white" size={20} />
          </button>
          <Popover
            id={popoverId}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
          >
            <div className={`${classes.scenarioActions}`}>
              <ButtonWithExportScenario />
              <Tooltip title="Remove scenario" disableFocusListener>
                <button
                  type="button"
                  onClick={() => {
                    handleRemoveScenario(scenarioId);
                  }}
                  className={classes.button}
                >
                  <TiTrash color="#e07670" size={30} />
                </button>
              </Tooltip>
            </div>
          </Popover>
        </>
      )}
    </>
  );
};

export default ScenarioOptions;
